import { AboutUs } from '@/components/screens/landing/about-us';
import { GetStaticProps, NextPage } from 'next';

const AboutUsPage: NextPage = () => {
	return <AboutUs />;
};

export const getStaticProps: GetStaticProps = async () => {
	return { props: {} };
};

export default AboutUsPage;
